import { render, staticRenderFns } from "./SaveToDropbox.vue?vue&type=template&id=9fa40c32&"
import script from "./SaveToDropbox.vue?vue&type=script&lang=js&"
export * from "./SaveToDropbox.vue?vue&type=script&lang=js&"
import style0 from "./SaveToDropbox.vue?vue&type=style&index=0&id=9fa40c32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports